import React from 'react';

import Pages from './Pages';
import ProductItems from './ProductItems';
import { ILanguage } from '@/interfaces/languages';
import UserUtils from './UserUtils';
import { IPageContext } from '@/interfaces/pageContext';
import {
  addExternalLinksFlag,
  DistributePages,
} from '@/components/Headers/MainHeader/utils';
import { Languages } from '@/lib/LanguagesIncludingIcons';
import { mountUrl } from '@/shared/helpers';
import { OrganizeProductsByCategory } from '@/lib/OrganizeProductsByCategory';

import './styles.scss';

type Props = {
  pageContext: IPageContext;
};

const Desktop = ({ pageContext }: Props) => {
  const { pathLang, currentPath, lang, appData, categoriesWithProducts } =
    pageContext;
  const { isMultiLanguage, locale, products, templateData } = appData;
  const { general, home, menu, pages } = templateData;
  const { logoUrl, colors } = general;

  const logoSize = parseInt(general.logoSize);
  const { productsWithoutCategory } = OrganizeProductsByCategory(products);
  const productsToListInMenu = menu.categoriesMenu
    ? productsWithoutCategory
    : products;
  const externalLinks = addExternalLinksFlag(menu.externalLinks);

  let extendedPages = menu.categoriesMenu
    ? [...categoriesWithProducts, ...pages]
    : pages;
  extendedPages = [...extendedPages, ...externalLinks];

  const { mainPages, wrappedPages } = DistributePages(extendedPages);
  const shouldApplyContrast = colors.contrast;
  const currentLanguage =
    Languages.find((thisLang) => thisLang.lang === lang) || ({} as ILanguage);

  return (
    <>
      <div>
        <a href={mountUrl(pathLang)} className="brand-logo">
          <img src={logoUrl} alt="logo" height={logoSize ? logoSize : '60'} />
        </a>
      </div>

      <nav className="navbar">
        <ul className="navbar-list">
          {productsToListInMenu.length > 0 ? (
            <ProductItems
              lang={lang}
              locale={locale}
              pathLang={pathLang}
              products={productsToListInMenu}
              shouldApplyContrast={shouldApplyContrast}
              shouldDisplayProductsPage={home.productList.productListingPage}
            />
          ) : null}

          <Pages
            locale={locale}
            pathLang={pathLang}
            pages={mainPages}
            wrappedPages={wrappedPages}
            shouldApplyContrast={shouldApplyContrast}
            language={lang}
          />

          <UserUtils
            pathLang={pathLang}
            shouldApplyContrast={shouldApplyContrast}
            currentLanguage={currentLanguage}
            currentPath={currentPath}
            isMultiLanguage={isMultiLanguage}
          />
        </ul>
      </nav>
    </>
  );
};

export default Desktop;
